export default __webpack_public_path__ + "static/media/dog-collars.270eff58.png";